export type OrderCardProduct = { name: string; code?: string | null };

export const NO_PRODUCTS: OrderCardProduct[] = [];

export type OrderCardPlant = { name: string; code?: string | null };
